// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ModeStatus } from './mode-status';


export class ModeStatusMessage implements flatbuffers.IUnpackableObject<ModeStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ModeStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsModeStatusMessage(bb:flatbuffers.ByteBuffer, obj?:ModeStatusMessage):ModeStatusMessage {
  return (obj || new ModeStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsModeStatusMessage(bb:flatbuffers.ByteBuffer, obj?:ModeStatusMessage):ModeStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ModeStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():ModeStatus {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ModeStatus.Attendant;
}

static startModeStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:ModeStatus) {
  builder.addFieldInt16(0, message, ModeStatus.Attendant);
}

static endModeStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createModeStatusMessage(builder:flatbuffers.Builder, message:ModeStatus):flatbuffers.Offset {
  ModeStatusMessage.startModeStatusMessage(builder);
  ModeStatusMessage.addMessage(builder, message);
  return ModeStatusMessage.endModeStatusMessage(builder);
}

unpack(): ModeStatusMessageT {
  return new ModeStatusMessageT(
    this.message()
  );
}


unpackTo(_o: ModeStatusMessageT): void {
  _o.message = this.message();
}
}

export class ModeStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: ModeStatus = ModeStatus.Attendant
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return ModeStatusMessage.createModeStatusMessage(builder,
    this.message
  );
}
}
